export default __webpack_public_path__ + "static/media/Group7.0f0f18f5.svg";